import React, { Component, useContext } from 'react';
import { Route, Redirect } from 'react-router';
import { Layout } from './components/Layout';
import { UserContext } from './context/UserProvider';
import { UserRole } from './constants';
import { Classification } from './pages/Classification/Classification';
import { Calendar } from './pages/Calendar/Calendar';
import { Home } from './pages/Home/Home';
import { Results } from './pages/Results/Results';
import { Match } from './pages/Match/Match';
import { Player } from './pages/Player/Player';
import { PlayerStats } from './pages/PlayerStats/PlayerStats';
import { Division } from './pages/Divisions/Division';
import { Divisions } from './pages/Divisions/Divisions';
import { Teams } from './pages/Teams/Teams';
import { Places } from './pages/Places/Places';
import { Products } from './pages/Products/Products';
import { Regulation } from './pages/Regulation/Regulation';
import { Game } from './pages/Game/Game';
import { Rules } from './pages/Game/Rules';
import { Login } from "./pages/Auth/Login"
import { SignUp } from "./pages/Auth/SignUp"
import { CustomGameList } from './pages/CustomGame/CustomGameList'
import { CustomGameForm } from './pages/CustomGame/CustomGameForm'
import { Players } from './pages/Players/Players'
import { ArcadeGame } from './pages/ArcadeGame/ArcadeGame'
import { Coach } from './pages/Coach/Coach'
import TacticView from './pages/Coach/TacticView'

import './custom.css'

function AdminRoute({ component: Component, ...rest }) {
    const { role } = useContext(UserContext);
    return (
        <Route {...rest} render={props =>
            role === UserRole.Admin
                ? <Component {...props} />
                : <Redirect to="/" />
        } />
    );
}

function UserRoute({ component: Component, ...rest }) {
    const { user } = useContext(UserContext);
    return (
        <Route {...rest} render={props =>
            user != null ? <Component {...props} /> : <Redirect to="/login" />
        } />
    );
}

export default class App extends Component {
    static displayName = App.name;

    render() {

        return (
            <Layout>
                <Route exact path='/' component={Results} />

                <Route path="/login" component={Login} />
                <Route path="/signup" component={SignUp} />
                <Route path='/playerstats' component={PlayerStats} />
                <Route path='/players' component={Players} />
                <Route path='/calendars' component={Calendar} />
                <Route path='/classification/' component={Classification} />
                <Route path='/info' component={Home} />
                <Route path='/player/:id' component={Player} />
                <Route path='/match/:id' component={Match} />
                <Route path='/division/:id' component={Division} />
                <Route exact path='/game/docs/rules' component={Rules} />
                <Route exact path='/game/:id' component={Game} />
                <Route path='/divisions' component={Divisions} />
                <Route path='/teams' component={Teams} />
                <Route path='/products' component={Products} />
                <Route path='/places' component={Places} />
                <Route path='/regulation' component={Regulation} />
                <AdminRoute exact path='/customgames' component={CustomGameList} />
                <AdminRoute path='/customgames/:id' component={CustomGameForm} />
                <Route path='/arcade' component={ArcadeGame} />
                <UserRoute path='/coach' component={Coach} />
                <Route path='/tactic/:userId/:tacticId' component={TacticView} />
            </Layout>
        );
    }
}
